var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import { Container } from 'reactstrap';
import { map } from 'ramda';
import { DropdownIcon, DropdownMenu, Divider, NavFrame, MobileMenuFrame, MenuBtn, BarMenuTitle, ExternalLink, Link, ExternalAction, Action, Container as CContainer } from './styled';

var toUpperCaseLabels = map(function (opt) {
  return _extends({}, opt, { label: opt.label.toUpperCase() });
});

var generateActionsLink = function generateActionsLink(options, ExternalAction, Action, Divider) {
  return options.map(function (_ref) {
    var to = _ref.to,
        label = _ref.label,
        classNames = _ref.classNames,
        external = _ref.external,
        isActive = _ref.isActive;
    return React.createElement(
      Fragment,
      { key: label },
      external ? React.createElement(
        ExternalAction,
        { key: label, href: to, className: classNames },
        label
      ) : React.createElement(
        Action,
        { key: label, to: to, className: classNames, isActive: isActive },
        label
      )
    );
  });
};

export var DropDown = function DropDown(_ref2) {
  var options = _ref2.options,
      isOpen = _ref2.isOpen,
      toggleDropdown = _ref2.toggleDropdown,
      _ref2$CompLink = _ref2.CompLink,
      CompLink = _ref2$CompLink === undefined ? Action : _ref2$CompLink;
  return React.createElement(
    DropdownMenu,
    { onClick: function onClick() {
        return toggleDropdown(!isOpen);
      }, isOpen: isOpen },
    generateActionsLink(options, ExternalAction, CompLink, Divider)
  );
};

export var NavBar = function NavBar(_ref3) {
  var options = _ref3.options,
      _ref3$CompLink = _ref3.CompLink,
      CompLink = _ref3$CompLink === undefined ? Link : _ref3$CompLink;
  return React.createElement(
    NavFrame,
    null,
    generateActionsLink(options, ExternalLink, CompLink)
  );
};

export var MobileNav = function MobileNav(_ref4) {
  var title = _ref4.title,
      menuTitle = _ref4.menuTitle,
      options = _ref4.options,
      CompLink = _ref4.CompLink;

  var _useState = useState(false),
      isOpen = _useState[0],
      toggleDropdown = _useState[1];

  return React.createElement(
    Fragment,
    null,
    React.createElement(
      MobileMenuFrame,
      null,
      React.createElement(
        CContainer,
        null,
        React.createElement(
          BarMenuTitle,
          null,
          title
        ),
        React.createElement(
          MenuBtn,
          { onClick: function onClick() {
              return toggleDropdown(!isOpen);
            }, open: isOpen },
          menuTitle,
          React.createElement(DropdownIcon, { open: isOpen })
        )
      )
    ),
    React.createElement(DropDown, { options: options, isOpen: isOpen, toggleDropdown: toggleDropdown, CompLink: CompLink })
  );
};

var SecondaryNav = function SecondaryNav(_ref5) {
  var title = _ref5.title,
      menuTitle = _ref5.menuTitle,
      options = _ref5.options,
      breakpoint = _ref5.breakpoint,
      CompLink = _ref5.CompLink;
  return React.createElement(
    Fragment,
    null,
    React.createElement(
      MediaQuery,
      { maxWidth: breakpoint - 1 },
      React.createElement(MobileNav, { title: title, menuTitle: menuTitle, options: options, CompLink: CompLink })
    ),
    React.createElement(
      MediaQuery,
      { minWidth: breakpoint },
      React.createElement(
        Container,
        null,
        React.createElement(NavBar, { options: toUpperCaseLabels(options), CompLink: CompLink })
      )
    )
  );
};

SecondaryNav.defaultProps = {
  breakpoint: 998
};

SecondaryNav.propTypes = process.env.NODE_ENV !== "production" ? {
  breakpoint: PropTypes.number,
  title: PropTypes.string,
  menuTitle: PropTypes.string,
  CompLink: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    external: PropTypes.bool,
    label: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired,
    classNames: PropTypes.string
  }))
} : {};

export default SecondaryNav;